import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/ma2.png';
import styles from '../styles/legal.module.css';
import { 
  FaSearch, 
  FaMapMarkerAlt, 
  FaArrowRight, 
  FaLeaf,
  FaTag,
  FaHeart,
  FaStore,
  FaInstagram,
  FaWhatsapp,
  FaChevronLeft,
  FaChevronRight,
  FaTimes
} from 'react-icons/fa';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.legalContainer}>

      {/* HEADER */}
      <header className={styles.legalHeader}>
        <div className={styles.legalHeaderContainer}>
          <Link to="/" className={styles.legalLogo}>
            <img src={logo} alt="Mercado Abierto" className={styles.legalLogoImg} />
          </Link>
        </div>
      </header>

      <main className={styles.legalMainContent}>
  <div className={styles.legalContent}>
    
    <button onClick={() => navigate('/')} className={styles.backButton}>
      ← Volver al inicio
    </button>

    <h1 className={styles.legalTitle}>Términos y Condiciones de Uso</h1>
    <p className={styles.legalDate}>Última actualización: 23 de junio de 2026</p>

    <div className={styles.legalSection}>
      <h2>1. Aceptación de los términos</h2>
      <p>
        Al acceder y utilizar MercadoAbierto.online (en adelante "la 
        Plataforma"), el usuario acepta los presentes Términos y Condiciones 
        de Uso. Si no está de acuerdo con estos términos, debe abstenerse de 
        utilizar la Plataforma.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>2. Descripción del servicio</h2>
      <p>
        MercadoAbierto.online es una plataforma informativa que tiene como 
        objetivo mostrar información sobre mercados municipales ubicados en la 
        república mexicana, sus locales, productos, servicios y <strong>locatarios</strong> 
        (comerciantes que ocupan y atienden los locales).
      </p>
      <p>
        La Plataforma actúa exclusivamente como un intermediario tecnológico 
        que facilita el acceso a la información, sin intervenir en las 
        transacciones comerciales que puedan realizarse entre los usuarios y 
        los <strong>locatarios</strong> o anunciantes.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>3. Responsabilidad sobre la información</h2>
      <p>
        <strong>MercadoAbierto.online NO es responsable:</strong>
      </p>
      <ul>
        <li>
          De la veracidad, exactitud, integridad o actualización de la 
          información proporcionada por los administradores de los mercados 
          y <strong>locatarios</strong>.
        </li>
        <li>
          De la calidad, seguridad, legalidad o disponibilidad de los 
          productos y servicios ofrecidos por los <strong>locatarios</strong> y anunciantes.
        </li>
        <li>
          De cualquier transacción comercial, acuerdo o negociación que se 
          realice entre los usuarios y los <strong>locatarios</strong> o anunciantes.
        </li>
        <li>
          De los daños o perjuicios que pudieran derivarse del uso de la 
          información publicada en la Plataforma.
        </li>
      </ul>
      <p>
        La información mostrada en la Plataforma es proporcionada de buena 
        fe por los administradores de los mercados y <strong>locatarios</strong>, quienes son 
        los únicos responsables de su veracidad y actualización.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>4. Limitación de responsabilidad</h2>
      <p>
        MercadoAbierto.online actúa como un mero intermediario tecnológico 
        que muestra información pública. En consecuencia:
      </p>
      <ul>
        <li>
          <strong>No interviene</strong> en las transacciones entre usuarios 
          y <strong>locatarios</strong> o anunciantes.
        </li>
        <li>
          <strong>No garantiza</strong> la existencia, calidad, seguridad, 
          legalidad o adecuación de los productos y servicios ofrecidos por 
          los <strong>locatarios</strong>.
        </li>
        <li>
          <strong>No se hace responsable</strong> de los acuerdos, contratos 
          o negociaciones que se realicen como resultado de la información 
          proporcionada en la Plataforma.
        </li>
      </ul>
      <p>
        Cualquier disputa, reclamo o controversia que surja entre un usuario 
        y un <strong>locatario</strong> o anunciante deberá ser resuelta directamente entre las partes 
        involucradas, sin la intervención de MercadoAbierto.online.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>5. Usuarios y anunciantes</h2>
      <h3>5.1 Usuarios</h3>
      <p>
        Los usuarios acceden a la Plataforma para consultar información sobre 
        mercados, locales, productos, servicios y <strong>locatarios</strong>. Los usuarios son 
        responsables de verificar la información por sus propios medios antes 
        de realizar cualquier transacción.
      </p>
      
      <h3>5.2 Locatarios y anunciantes</h3>
      <p>
        Los <strong>locatarios</strong> (comerciantes que ocupan y atienden los locales) y 
        anunciantes son quienes proporcionan la información publicada en la 
        Plataforma. Son los únicos responsables de:
      </p>
      <ul>
        <li>La veracidad y actualización de la información proporcionada.</li>
        <li>La calidad y seguridad de los productos y servicios ofrecidos.</li>
        <li>El cumplimiento de las disposiciones legales aplicables.</li>
        <li>La atención de los reclamos de los usuarios.</li>
      </ul>
      <p>
        La Plataforma no verifica ni avala la información proporcionada por 
        los <strong>locatarios</strong> y anunciantes, por lo que los usuarios deben ejercer 
        su propio criterio al momento de realizar cualquier transacción.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>6. Propiedad intelectual</h2>
      <p>
        Todo el contenido de la Plataforma, incluyendo pero no limitado a 
        textos, imágenes, logotipos, iconos y diseño, es propiedad de 
        MercadoAbierto.online o de sus respectivos titulares, y está 
        protegido por las leyes de propiedad intelectual aplicables.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>7. Legislación aplicable</h2>
      <p>
        Los presentes Términos y Condiciones se rigen por las leyes de los 
        Estados Unidos Mexicanos, en particular por el Código Civil Federal, 
        el Código de Comercio y el Código Civil del Estado de Michoacán de 
        Ocampo.
      </p>
      <p>
        Cualquier controversia derivada del uso de la Plataforma será resuelta 
        por los tribunales competentes de la ciudad de Morelia, Michoacán.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>8. Modificaciones</h2>
      <p>
        MercadoAbierto.online se reserva el derecho de modificar los presentes 
        Términos y Condiciones en cualquier momento. Las modificaciones serán 
        publicadas en esta misma página y entrarán en vigor a partir de su 
        publicación.
      </p>
    </div>

    <div className={styles.legalSection}>
      <h2>9. Contacto</h2>
      <p>
        Para cualquier duda o aclaración sobre estos Términos y Condiciones, 
        puedes contactarnos en:
      </p>
      <p>
        <strong>Correo electrónico:</strong> mercadoabierto@email.com
      </p>
    </div>

  </div>
</main>

      {/* FOOTER */}
      <footer className={styles.legalFooter}>
        <div className={styles.legalFooterGrid}>
          <div>
            <img src={logo} alt="logo" className={styles.legalFooterLogo} />
            <p>Plataforma digital que conecta a los mercados municipales de México contigo.</p>
          </div>
          <div>
            <h4>Enlaces rápidos</h4>
            <p onClick={() => navigate('/')}>Inicio</p>
            <p onClick={() => navigate('/')}>Explorar mercados</p>
          </div>
          <div>
            <h4>Síguenos</h4>
            <div className={styles.socials}>
              <FaInstagram size={28} />
              <FaWhatsapp size={28} />
            </div>
          </div>
        </div>
       <div className={styles.mapFooterBottom}>
            © {new Date().getFullYear()} mercadoabierto.online - Todos los derechos reservados
        </div>
      </footer>

    </div>
  );
};

export default Terms;